import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Bonuses from 'routes/Products/components/Bonuses';

class BonusesPage extends PureComponent {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return <Bonuses {...this.props} />;
  }
}

BonusesPage.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  Children: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  data: PropTypes.shape({}).isRequired
};

export default BonusesPage;
